<script>
  import estados from '~js/estados';
  import Radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';

  export default {
    components: { Radio, checkbox },
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      itensSolicitacaoImportacao: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        estados: estados,
        configuracao: this.$storage.configuracao(),
        tipoItem: '0',
      }
    },
    computed: {
      observacaoItemImportacaoContador: function() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemImportacao ? 
            this.itemSolicitacao.observacaoItemImportacao.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      resetarTipo() {
        this.tipoItem = '0';
      },
      mudarTipoItem() {
        this.$validator.reset();

        const codigoItem = document.getElementById("codigoItem");
        codigoItem.removeAttribute('disabled');
        const quantidade = document.getElementById("quantidade");
        quantidade.removeAttribute('disabled');
        const unidade = document.getElementById("unidade");
        unidade.removeAttribute('disabled');
        const nomeFabricante = document.getElementById("nomeFabricante");
        nomeFabricante.removeAttribute('disabled');
        const NCMHSCode = document.getElementById("NCMHSCode");
        NCMHSCode.removeAttribute('disabled');

        this.itemSolicitacao.despesaCapital = false;
        this.itemSolicitacao.servico = false;
        this.itemSolicitacao.materialConsumo = false;

        this.itemSolicitacao.quantidade = null;

        switch (this.tipoItem) {
          case '1':
            this.itemSolicitacao.despesaCapital = true;
            break;
          case '2':
            this.itemSolicitacao.materialConsumo = true;
            break;
          case '3':
            $('#codigoItem').attr('disabled', 'disabled');
            $('#quantidade').attr('disabled', 'disabled');
            $('#unidade').attr('disabled', 'disabled');
            $('#nomeFabricante').attr('disabled', 'disabled');
            $('#NCMHSCode').attr('disabled', 'disabled');
            this.itemSolicitacao.servico = true;
            this.itemSolicitacao.quantidade = '1,00';
            this.itemSolicitacao.unidade = '';
            this.itemSolicitacao.nomeFabricante = '';
            this.itemSolicitacao.NCMHSCode = '';
            break;
          default:
        }
      },
      desabilitarCampos() {
        if (this.itensSolicitacaoImportacao.length == 0)
          return false
        else {
          return (this.itensSolicitacaoImportacao[0].servico);
        }
      },
      desabilitarCamposServico() {
        if (this.itensSolicitacaoImportacao.length == 0)
          return false
        else {

          return (this.itensSolicitacaoImportacao[0].despesaCapital || this.itensSolicitacaoImportacao[0].materialConsumo);
        }
      },
    },
    watch: {
      'tipoItem': 'mudarTipoItem',
    },
  }
</script>

<template>
  <div>
    <h3 class="m-t m-b">Elemento de Despesa</h3>
    <div class="hr-line-dashed margin-top-5"></div>

    <div class="row">
      <div class="col-xs-4">
        <div class="form-group">
          <radio v-model="tipoItem"
                 id="despesa"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 :disabled="desabilitarCampos()"
                 class="margin-right-10">
            Despesa de Capital
          </radio>
          <radio v-model="tipoItem"
                 id="material"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 :disabled="desabilitarCampos()"
                 class="margin-right-10">
            Material de Consumo
          </radio>
          <radio v-model="tipoItem"
                 id="servico"
                 selected-value="3"
                 type="success"
                 :disabled="desabilitarCamposServico()"
                 :inline="true">
            Serviço
          </radio>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed"></div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
          <label class="control-label" for="descricao-material">Descrição do material/serviço</label>

          <textarea class="form-control"
                    id="descricao-material"
                    v-model="itemSolicitacao.descricao"
                    v-validate="'required'"
                    data-vv-name="descricaoMaterial"
                    data-vv-as="descrição do material/serviço">
          </textarea>

          <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-4">
        <div class="form-group" :class="{'has-error': errors.has('codigoItem')}">
          <label class="control-label" for="codigoItem">Código do item</label>

          <input type="text"
                 class="form-control"
                 id="codigoItem"
                 v-model="itemSolicitacao.codigoItem"
                 data-vv-name="codigoItem"
                 maxlength="20">

          <p class="text-danger" v-show="errors.has('codigoItem')">{{ errors.first('codigoItem') }}</p>
        </div>
      </div>

      <div :class="[configuracao.utilizarValorEstimadoImportacao ? 'col-xs-2' : 'col-xs-4']">
        <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
          <label class="control-label" for="quantidade">Quantidade</label>

          <input type="text"
                 class="form-control text-right"
                 id="quantidade"
                 v-model="itemSolicitacao.quantidade"
                 data-vv-name="quantidade"
                 v-validate="'required|not_zero'"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
        </div>
      </div>

      <div class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
        <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
          <label class="control-label" for="valor-estimado">Valor unitário estimado</label>

          <input type="text"
                 class="form-control text-right"
                 id="valor-estimado"
                 v-model="itemSolicitacao.valorEstimado"
                 data-vv-name="valorEstimado"
                 v-validate="'required|not_zero'"
                 data-vv-as="valor estimado"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('desconto')}">
          <label class="control-label" for="desconto">Desconto total</label>

          <input type="text"
                 class="form-control text-right"
                 id="desconto"
                 v-model="itemSolicitacao.desconto"
                 data-vv-name="desconto"
                 data-vv-as="desconto"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('desconto')">{{ errors.first('desconto') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('vat')}">
          <label class="control-label" for="vat">Vat %</label>

          <input type="text"
                 class="form-control text-right"
                 id="vat"
                 v-model="itemSolicitacao.vat"
                 data-vv-name="vat"
                 data-vv-as="vat"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('vat')">{{ errors.first('vat') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('unidade')}">
          <label class="control-label" for="unidade">Unidade</label>

          <input type="text"
                 class="form-control"
                 id="unidade"
                 v-model="itemSolicitacao.unidade"
                 data-vv-name="unidade"
                 maxlength="15">

          <p class="text-danger" v-show="errors.has('unidade')">{{ errors.first('unidade') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('NCMHSCode')}">
          <label class="control-label" for="NCMHSCode">NCM ou HS CODE</label>

          <input type="text"
                 class="form-control"
                 id="NCMHSCode"
                 v-model="itemSolicitacao.ncmhsCode"
                 data-vv-name="NCM ou HS code"
                 maxlength="25">

          <p class="text-danger" v-show="errors.has('NCMHSCode')">{{ errors.first('NCMHSCode') }}</p>
        </div>
      </div>

      <div class="col-xs-4">
        <div class="form-group" :class="{'has-error': errors.has('nomeFabricante')}">
          <label class="control-label" for="nomeFabricante">Nome fabricante</label>

          <input type="text"
                 class="form-control"
                 id="nomeFabricante"
                 v-model="itemSolicitacao.nomeFabricante"
                 data-vv-name="nome fabricante"
                 maxlength="35">

          <p class="text-danger" v-show="errors.has('nomeFabricante')">{{ errors.first('nomeFabricante') }}</p>
        </div>
      </div>

      <div class="col-xs-4">
        <div class="form-group" :class="{'has-error': errors.has('paisProcedencia')}">
          <label class="control-label" for="paisProcedencia">País procedência</label>

          <input type="text"
                 class="form-control"
                 id="paisProcedencia"
                 v-model="itemSolicitacao.paisProcedencia"
                 data-vv-name="país procedência"
                 maxlength="35">

          <p class="text-danger" v-show="errors.has('paisProcedencia')">{{ errors.first('paisProcedencia') }}</p>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed"></div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <div class="checkbox">
            <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
              Manter observação do item de importação (caso esta solicitação
              demandar outros itens com a mesma observação)
            </checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="observacao-item-compra">Observação do item de importação ({{ observacaoItemImportacaoContador }})</label>

          <textarea class="form-control"
                    id="observacao-item-compra"
                    v-model="itemSolicitacao.observacaoItemImportacao"
                    maxlength="500">
          </textarea>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao/componentes/compartilhado/FormImportacao.vue